import { createAction, props } from '@ngrx/store';

export const setBrokerSessionInfo = createAction(
  '[Broker Session Info]',
  props<{ brokerSessionInfo: any }>()
);

export const setUserGroups = createAction(
  '[User Groups]',
  props<{ userGroups: any }>()
);
